import React from 'react';
import PropTypes from 'prop-types'; // eslint-disable-line import/no-extraneous-dependencies

const TextContent = ({ children }) => (
  <div className="textcontent">
    {children}
  </div>
);

TextContent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

TextContent.defaultProps = {
  children: [],
};

export default TextContent;
